/* nsh-quiz-seq.js - display order layer (theme v13.14, 2026-10-21; first screen on the question card 2026-10-22; 2026-10-22c: (1) the age
   screen has no eyebrow any more (NSH_Q1.last removed; its title / sub line live in nsh-quiz-v11.js). (2) mobile: screens drawn outside
   render() (one-more, detail screens) were scrolled to 24% of the viewport by rise(), while every engine screen goes through the
   v10a steady layout (fixed sheet margin + scrollTo(0,0)) wrapped around render() / layoutSheet(); the detail screen (drawn from a
   timer after the one-more tap) therefore sat lower than the other questions. rise() now calls window.layoutSheet() (v10a-wrapped).
   (3) result: the brand line is the first line inside p.v9-rlabel (span.v13-brand-in + <br>, same style as the label), no separate
   p.v13-brand. (4) done(): engine-2 renderSlots() needs #slotDisclose and #prodNote, which the friend view drops; a hidden empty
   placeholder is put back in #slotSec before finish() so "try it yourself" from a friend's result reaches the result. 2026-10-22b: the detail
   answers (run.det, written on each detail screen's next tap) are readable at any time through window.NSH_seqDetail(), which
   nsh-quiz-v13q.js uses when __nshDPending is empty at finish; cleared only by first() / restart, filtered by the current concerns). ASCII only;
   every string comes from window.NSH_Q1 (snippets/nsh-quiz-copy, emitted by templates/page.nsh-quiz.liquid) or from the live
   question data (Q, NSH_V13).
   2026-10-22: the first screen is drawn on the standard question card (#quiz: .progress #count/#fill, #qcard, p.q#qText,
   div.opts#opts.nsk-cols with button.opt > span.k + span.ot, like the old question 16 and the "one more" screen), no longer
   in #intro. Count 01 / TT, back link hidden (like the engine's first question). The small top line (intro_btn, the
   p.btn-bar of #intro with the 60 glyphs of nsh-quiz-num.js) is shown as the card's eyebrow p#nshSeqLead.nsh-seq-lead
   (the age screen had the same eyebrow until 2026-10-22c). #intro stays in the page (hidden): the engine, the tracking
   layer (intro observer) and restart still pass through show('intro'); the first screen is put on #quiz in the microtask
   right after (or right after nsh-quiz-num.js redraws a changed count), so the tracking layer still sees the intro
   (quiz_start reset on restart, __nshSeqBack on back). Count / text are written and redrawn while #quiz is hidden, so
   nsh-quiz-track.js sends no quiz_q for screen 1 (same events as before). The cookie footnote (.nsh-q1-foot) and a carry
   notice (#nshCarry) move to #quiz and show only while #quiz has .nsh-first.

   The question array Q and the answer string a= stay exactly as before (slot order: 0 age, 1 gender, 2 wash_temp ... 15 trouble,
   16 concern; nshQuizR, shared / calendar / own links and every replay keep working). Only the order on screen changes:
     1  first screen (#quiz card, see above): the concern question. A tap records concern #1 (answers[16]) and starts the run.
     2  "one more?" (#quiz): the other concerns + "none"  -> window.__nshC2 (same meaning as v8b2). Skipped when #1 is "none".
     3  detail screens for spots / dark circles (same data and UI as nsh-quiz-v13q.js, moved here from finish time).
     4  wash_temp ... trouble in the old order, through the engine's own render / commit (mf still skipped when bump = none).
     5  age + gender (v11's combined screen); both picked -> finish().
   How: render / back / start / restart are wrapped. The engine still moves idx forward on its own (v7b step, v11 age screen,
   carry's pre-answered question); this layer only maps where that lands: past trouble -> age screen, past age -> finish.
   Final answers and acc are the same as the old order (acc sums are order free; back() rebuilds acc from the screens before).
   Count "NN / TT" follows the new order (hidden questions out, mf counted as before). Tracking: NSH_seqAt(n) for
   nsh-quiz-track.js v5.2, NSH_trackQ1Start() on the first tap. Result: the brand line inside #nshV9 .v9-rlabel (first line). */
(function(){
  if(window.__NSH_SEQ)return; window.__NSH_SEQ=1;
  var W=window,D=document,T=W.NSH_Q1||{};
  if(!T.q)return;
  var MAIN0=2,MAIN1=15;          /* wash_temp .. trouble */
  var run=null,pend=null,preIdx=-1;

  function $(id){return D.getElementById(id)}
  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}
  function X(){return W.NSH_V13||null}
  function ucf(t){t=String(t||'');var x=X();return x&&x.lang==='en'?t.charAt(0).toUpperCase()+t.slice(1):t}
  function pad(n){return (n<10?'0':'')+n}
  function ci(){try{for(var i=0;i<Q.length;i++)if(Q[i]&&Q[i].id==='concern')return i}catch(e){}return -1}
  function cq(){var i=ci();return i>=0?Q[i]:null}
  function apply(qi,a){try{if(a===undefined||a===null)return;W.NSH_applyAns(qi,a)}catch(e){}}
  function shownQ(qi){var q=Q[qi];return !!q&&!q.hidden}

  /* ---- carry (note links): its notice is placed after '#intro .sub'; give it a hidden anchor above the question ---- */
  var SP=null;try{SP=new URL(location.href).searchParams}catch(e){}
  (function(){
    try{
      if(!SP||!/^note-/i.test(SP.get('ref')||'')||SP.get('state')||SP.get('a')||SP.get('qa'))return;
      var m=/^([a-z_]+)\.(\d{1,2})$/.exec(SP.get('pre')||'');if(!m)return;
      if(m[1]==='concern')preIdx=parseInt(m[2],10);
      var q=$('nshQ1Q');if(!q||D.getElementById('nshCarryAnchor'))return;
      var p=D.createElement('p');p.className='sub';p.id='nshCarryAnchor';p.hidden=true;p.setAttribute('aria-hidden','true');
      q.parentNode.insertBefore(p,q);
    }catch(e){}
  })();

  /* ---- the screen list in the current state ---- */
  function c1Code(){try{var o=cq().o[answers[ci()]];return (o&&o.concern)||''}catch(e){return ''}}
  function c2Code(){try{var i2=W.__nshC2;if(i2===null||i2===undefined)return '';var o=cq().o[i2];return (o&&o.concern)||''}catch(e){return ''}}
  function detailList(){
    var x=X(),out=[];if(!x||!x.codeKey||!x.concerns)return out;
    var codes=[];var a=run?c1Code():'';if(a)codes.push(a);var b=run&&run.c2done?c2Code():'';if(b&&codes.indexOf(b)<0)codes.push(b);
    codes.forEach(function(c){var k=x.codeKey[c],K=k&&x.concerns[k];if(K&&K.q17)out.push(K)});
    return out;
  }
  function list(){
    var L=[{k:'c1'}];
    var noneFirst=run&&run.ph!=='c1'&&!c1Code();
    if(!noneFirst)L.push({k:'c2'});
    detailList().forEach(function(K){L.push({k:'d',K:K})});
    for(var qi=MAIN0;qi<=MAIN1;qi++)if(shownQ(qi))L.push({k:'q',qi:qi});
    if(shownQ(0))L.push({k:'age'});
    return L;
  }
  function posOf(L,f){for(var i=0;i<L.length;i++)if(f(L[i]))return i;return -1}
  function curPos(L){
    if(!run)return 0;
    if(run.ph==='c2')return posOf(L,function(s){return s.k==='c2'});
    if(run.ph==='d')return posOf(L,function(s){return s.k==='d'&&s.K.code===run.dCode});
    if(run.ph==='main'){var p=posOf(L,function(s){return s.k==='q'&&s.qi===run.cur});if(p<0)p=posOf(L,function(s){return s.k==='q'&&s.qi>run.cur})-1;return p}
    if(run.ph==='age')return L.length-1;
    return 0;
  }
  W.NSH_shownTotal=function(){return list().length};
  /* tracking: screen n (1-based) of the current order */
  W.NSH_seqAt=function(n){
    var s=list()[n-1];if(!s)return null;
    if(s.k==='c1')return {id:'concern',qi:ci()};
    if(s.k==='c2'){var c=c2Code(),cc={T:'tone',C:'spots',A:'pores',K:'blackheads',B:'wrinkles',G:'trouble',F:'redness',E:'dark_circles'};return {id:'concern2',qi:-1,pick:c?(cc[c]||c):'none'}}
    if(s.k==='d')return {id:'detail_'+s.K.code,qi:-1,pick:(run&&run.det&&run.det[s.K.code]!==undefined)?run.det[s.K.code]:null};
    if(s.k==='age')return {id:'age',qi:0};
    return {id:(Q[s.qi]&&Q[s.qi].id)||'',qi:s.qi};
  };

  /* ---- shared bits of a #quiz screen ---- */
  function head(n,total){
    var c=$('count'),f=$('fill');
    if(c){var t=pad(n)+' / '+pad(total);if(c.textContent!==t)c.textContent=t}
    if(f)f.style.width=((n-1)/total*100)+'%';
    var b=$('backBtn');if(b)b.style.visibility=run?'visible':'hidden';
    var ld=$('nshSeqLead');
    if(!run){
      if(!ld){var qt=$('qText');if(qt){ld=D.createElement('p');ld.id='nshSeqLead';ld.className='nsh-seq-lead';qt.parentNode.insertBefore(ld,qt)}}
      if(ld)topLine(ld);
    }else if(ld)ld.parentNode.removeChild(ld);
  }
  /* first screen eyebrow = the live #intro p.btn-bar (painted text + nsh-quiz-num.js glyphs), else NSH_Q1.top */
  function topLine(ld){
    var s=D.querySelector('#intro .btn-bar'),h=s&&s.innerHTML&&(s.textContent||'').replace(/\s+/g,'')?s.innerHTML:esc(T.top||'');
    if(ld.innerHTML!==h)ld.innerHTML=h;
  }
  function rise(){var c=$('qcard');if(c){c.classList.remove('rise');void c.offsetWidth;c.classList.add('rise')}
    /* same placement as an engine screen: layoutSheet() as wrapped by nsh-quiz-v10a.js (mobile: fixed sheet margin, scrollTo(0,0)) */
    try{if(typeof W.layoutSheet==='function')W.layoutSheet();else if(W.matchMedia&&W.matchMedia('(max-width:880px)').matches)W.scrollTo(0,0)}catch(e){}}
  function chip(label,n,on){var b=D.createElement('button');b.className='opt'+(on?' sel':'');b.type='button';
    b.innerHTML='<span class="k">'+n+'</span><span class="ot">'+esc(label)+'</span>';return b}
  function ownScreen(){try{locked=true}catch(e){}try{idx=0}catch(e){}   /* engine keys (pick) ignore the age slot outside its screen */
    firstOff();if($('quiz').classList.contains('hidden'))show('quiz')}
  function firstOff(){var z=$('quiz');if(z)z.classList.remove('nsh-first')}

  /* ---- 1) first screen: the concern question on the standard card (#quiz) ---- */
  function q1Ready(){var x=X(),q=cq();return !!(x&&x.q16&&q&&q.o&&q.o.length===x.q16.length&&W.__NSH_V13Q&&W.__NSH_V11_Q&&typeof W.NSH_applyAns==='function')}
  function onFirst(){var z=$('quiz');return !run&&pend===null&&!!z&&z.classList.contains('nsh-first')&&!z.classList.contains('hidden')}
  function drawQ1(){   /* fills #quiz (called while #quiz is hidden, see first()) */
    var q=cq(),z=$('quiz'),qt=$('qText'),wrap=$('opts');if(!q||!z||!qt||!wrap)return;
    try{locked=true}catch(e){}try{idx=0}catch(e){}
    z.classList.add('nsh-first');
    qt.textContent=T.q;
    wrap.innerHTML='';wrap.classList.remove('nsk-two');wrap.classList.add('nsk-cols');
    wrap.setAttribute('role','group');wrap.setAttribute('aria-labelledby','qText');
    q.o.forEach(function(o,i){
      var b=chip(ucf(o.t),i+1,i===preIdx);
      b.onclick=function(){tapQ1(i,b)};
      wrap.appendChild(b);
    });
    var L=list();head(1,L.length);
    moveIn();
  }
  function tapQ1(i,b){
    if(!onFirst())return;
    [].forEach.call($('opts').querySelectorAll('.opt'),function(x){x.classList.toggle('sel',x===b);x.disabled=true});
    pend=i;
    try{if(typeof W.NSH_trackQ1Start==='function')W.NSH_trackQ1Start()}catch(e){}
    setTimeout(function(){
      W.__nshSeqRun=1;
      try{W.start()}catch(e){pend=null}
    },200);
  }
  function first(fromBack){
    run=null;pend=null;W.__nshSeqRun=0;W.__nshDPending=null;
    var o=$('opts');if(o){o.removeAttribute('role');o.removeAttribute('aria-labelledby')}
    if(fromBack)W.__nshSeqBack=1;
    try{show('intro')}catch(e){}   /* hides #quiz; the tracking layer's intro observer runs before the microtask below */
    if(!q1Ready()){setTimeout(function(){first(false)},60);return}
    drawQ1();
    var tk=++firstTk,c=$('count');
    /* a changed count is redrawn by nsh-quiz-num.js (debounced ~40 ms); #quiz is shown after that redraw, so the tracking
       layer's count observer only ever sees screen 1 while #quiz is hidden (no quiz_q for it, as before) */
    if(!c||c.querySelector('.nsk-vis')||!('MutationObserver' in W)){Promise.resolve().then(function(){reveal(tk)});return}
    var to=0,mo=new MutationObserver(function(){if(!c.querySelector('.nsk-vis'))return;mo.disconnect();clearTimeout(to);Promise.resolve().then(function(){reveal(tk)})});
    mo.observe(c,{childList:true,subtree:true});
    to=setTimeout(function(){mo.disconnect();reveal(tk)},400);
  }
  function reveal(tk){
    if(tk!==firstTk||run||pend!==null)return;
    var r=$('result');if(r&&!r.classList.contains('hidden'))return;
    var z=$('quiz');if(z&&!z.classList.contains('hidden'))return;
    try{show('quiz')}catch(e){}
    var c=$('qcard');if(c){c.classList.remove('rise');void c.offsetWidth;c.classList.add('rise')}
  }
  var firstTk=0;
  /* the cookie footnote and a carry notice (note links) belong to the first screen: kept in #quiz, shown with .nsh-first */
  function moveIn(){
    var z=$('quiz'),card=$('qcard');if(!z||!card)return;
    var f=D.querySelector('#intro .nsh-q1-foot');if(f)z.appendChild(f);
    var c=$('nshCarry');if(c&&c.parentNode!==card)card.insertBefore(c,card.firstChild);
  }

  /* ---- 2) one more concern ---- */
  function drawC2(){
    run.ph='c2';ownScreen();
    var q=cq(),c1=c1Code(),qt=$('qText'),wrap=$('opts');
    qt.textContent=T.c2;wrap.innerHTML='';wrap.classList.remove('nsk-two');wrap.classList.add('nsk-cols');
    var cur=W.__nshC2,n=0,btns=[];
    q.o.forEach(function(o,i){
      if(!o.concern||o.concern===c1)return;
      var b=chip(ucf(o.t),++n,run.c2done&&cur===i);b.onclick=function(){pickC2(i,b,btns)};btns.push(b);wrap.appendChild(b);
    });
    var nb=chip(T.none,++n,run.c2done&&(cur===null||cur===undefined));nb.onclick=function(){pickC2(null,nb,btns)};btns.push(nb);wrap.appendChild(nb);
    var L=list();head(curPos(L)+1,L.length);rise();
  }
  function pickC2(i,b,btns){
    if(run.busy)return;run.busy=1;
    btns.forEach(function(x){x.classList.toggle('sel',x===b);x.disabled=true});
    setTimeout(function(){run.busy=0;W.__nshC2=i;run.c2done=1;afterC2()},200);
  }
  function afterC2(){var L=detailList();if(L.length)drawD(L[0].code);else toMain()}

  /* ---- 3) detail screens (spots / dark circles): data and behaviour of nsh-quiz-v13q.js screen() ---- */
  function drawD(code){
    run.ph='d';run.dCode=code;ownScreen();
    var x=X(),K=null;detailList().forEach(function(k){if(k.code===code)K=k});if(!K)return toMain();
    var wrap=$('opts'),qt=$('qText');
    qt.textContent=ucf(x.q17.replace('{name}',K.name));
    wrap.innerHTML='';wrap.classList.remove('nsk-cols');wrap.classList.remove('nsk-two');
    var opts=K.q17.map(ucf);opts.push(ucf(x.q17unknown));
    var prev=run.det[code],sel={},btns=[];
    if(prev!==undefined){if(prev===0)sel[opts.length-1]=1;else opts.forEach(function(_,j){if(j<opts.length-1&&(prev&(1<<j)))sel[j]=1})}
    var nx=D.createElement('button');nx.className='btn-bar';nx.type='button';nx.textContent=x.q17next;nx.style.marginTop='14px';nx.disabled=!Object.keys(sel).length;
    opts.forEach(function(t,i){
      var b=chip(t,i+1,!!sel[i]);b.setAttribute('data-v13q','1');
      b.onclick=function(){
        if(i===opts.length-1){sel={};sel[i]=1}else{delete sel[opts.length-1];if(sel[i])delete sel[i];else sel[i]=1}
        btns.forEach(function(z,j){z.classList.toggle('sel',!!sel[j])});
        nx.disabled=!Object.keys(sel).length;
      };
      btns.push(b);wrap.appendChild(b);
    });
    nx.onclick=function(){
      var bits=0;Object.keys(sel).forEach(function(j){j=+j;if(j<opts.length-1)bits|=(1<<j)});
      run.det[code]=bits;
      var L=detailList(),k=-1;L.forEach(function(z,j){if(z.code===code)k=j});
      if(k>=0&&k<L.length-1)drawD(L[k+1].code);else toMain();
    };
    wrap.appendChild(nx);
    var Ls=list();head(curPos(Ls)+1,Ls.length);rise();
  }

  /* ---- 4) / 5) engine questions ---- */
  function rebuild(upto){   /* acc = concern + every engine answer before slot `upto` (as v7b back() does for the slots before) */
    try{resetAcc();apply(ci(),answers[ci()]);for(var k=MAIN0;k<upto&&k<=MAIN1;k++)apply(k,answers[k])}catch(e){}
  }
  function toMain(){
    run.ph='main';run.cur=MAIN0-1;
    try{locked=false}catch(e){}
    var o=$('opts');if(o){o.classList.remove('nsk-cols');o.classList.remove('nsk-two')}
    idx=MAIN0;W.render();
  }
  function toAge(){run.ph='age';run.cur=0;idx=0;return W.render()}   /* through the outer chain: a note link may have pre-answered age (carry) */
  /* the detail answers of the current run for the concerns picked now ({C:bits, E:bits}), null without a run or a detail concern */
  function detNow(){var d=null;try{if(!run)return null;var L=detailList();if(L.length){d={};L.forEach(function(K){d[K.code]=run.det[K.code]||0})}}catch(e){}return d}
  W.NSH_seqDetail=detNow;
  /* engine-2 renderSlots() writes #slotDisclose / #prodNote without a null check; the friend view removes both */
  function slotEls(){
    try{var sec=$('slotSec')||$('result');if(!sec)return;
      [['slotDisclose','sub-note'],['prodNote','prod-note']].forEach(function(z){if($(z[0]))return;
        var p=D.createElement('p');p.id=z[0];p.className=z[1];p.style.display='none';sec.appendChild(p)})}catch(e){}
  }
  function done(){
    run.ph='done';slotEls();
    W.__nshDPending=detNow();
    var ld=$('nshSeqLead');if(ld)ld.parentNode.removeChild(ld);
    try{idx=Q.length-1}catch(e){}
    try{W.finish()}finally{W.__nshSeqRun=0}
  }
  function fix(){if(!run||(run.ph!=='main'&&run.ph!=='age'))return;var L=list();head(curPos(L)+1,L.length)}

  var base={};
  function R(){
    if(!run){var z=$('quiz');if(pend!==null||(z&&z.classList.contains('nsh-first')))return;   /* a late re-render must not draw over the first screen */
      return base.render.apply(this,arguments)}
    if(run.ph==='boot'){
      var c=ci();answers[c]=run.c1;apply(c,run.c1);W.__nshC2=null;
      if(c1Code())return drawC2();
      return afterC2();
    }
    if(run.ph==='c2'||run.ph==='d'||run.ph==='done'||run.ph==='c1')return;   /* a late re-render from another layer: keep this screen */
    if(run.ph==='main'){
      if(idx>=MAIN0&&idx<=MAIN1){
        if(idx<run.cur)return;
        run.cur=idx;var r=base.render.apply(this,arguments);fix();return r;
      }
      if(idx>MAIN1||idx===ci()){var r2=toAge();fix();return r2}
      return;
    }
    if(run.ph==='age'){
      if(idx===0||idx===1){var r3=base.render.apply(this,arguments);fix();return r3}   /* 1 = hidden gender: v7b fills it and steps on */
      return done();
    }
  }
  function B(){
    if(!run||run.ph==='c1'||run.ph==='boot'||run.ph==='done')return base.back.apply(this,arguments);
    var L=list(),p=curPos(L)-1;
    while(p>0&&L[p].k==='q'&&Q[L[p].qi].showIf&&!Q[L[p].qi].showIf())p--;
    var s=L[p]||{k:'c1'};
    if(s.k==='c1')return first(true);
    if(s.k==='c2'){rebuild(MAIN0);return drawC2()}
    if(s.k==='d'){rebuild(MAIN0);return drawD(s.K.code)}
    if(s.k==='q'){rebuild(s.qi);run.ph='main';run.cur=s.qi;idx=s.qi;try{locked=false}catch(e){}var r=base.render.call(W);fix();return r}
  }
  function S(){
    if(pend!==null){
      var i=pend;pend=null;
      run={ph:'boot',c1:i,det:{},c2done:0};firstOff();
      var o=$('opts');if(o){o.removeAttribute('role');o.removeAttribute('aria-labelledby')}
      return base.start.apply(this,arguments);   /* idx 0, fresh answers / acc, #quiz shown, render() -> R (boot) */
    }
    first(false);
  }
  function RS(){var r=base.restart.apply(this,arguments);first(false);return r}

  function install(){
    if(W.render.__seq)return true;
    base.render=W.render;base.back=W.back;base.start=W.start;base.restart=W.restart;
    W.render=R;W.render.__seq=1;W.back=B;W.start=S;W.restart=RS;
    return true;
  }
  /* keys on the first screen: 1-9 tap a chip (the engine's own key handler is locked there) */
  D.addEventListener('keydown',function(e){
    try{if(!onFirst())return;var n=parseInt(e.key,10);if(!(n>=1&&n<=9))return;
      var b=$('opts').querySelectorAll('.opt')[n-1];if(b&&!b.disabled)b.click()}catch(e){}
  });

  /* ---- result: brand line (NSH_Q1.brand = intro_h1 without <br>) as the first line of the result label, owner and friend views:
     p.v9-rlabel = span.v13-brand-in + <br> + label text, so it takes the label's own font / size / colour / alignment.
     nsh-quiz-v13.js rebuilds #nshV9 by innerHTML; the observer puts the line back before the next paint (microtask). ---- */
  function brand(){
    if(!T.brand)return;
    var ls=D.querySelectorAll('#nshV9 .v9-rlabel');
    for(var i=0;i<ls.length;i++){var l=ls[i],f=l.firstChild;
      if(f&&f.nodeType===1&&f.classList&&f.classList.contains('v13-brand-in')){if(f.textContent!==T.brand)f.textContent=T.brand;continue}
      var b=D.createElement('span');b.className='v13-brand-in';b.textContent=T.brand;
      l.insertBefore(D.createElement('br'),l.firstChild);l.insertBefore(b,l.firstChild)}
    var old=D.querySelectorAll('#nshV9 p.v13-brand');for(var k=0;k<old.length;k++)old[k].parentNode.removeChild(old[k]);
  }
  function brandWatch(){try{brand();if('MutationObserver' in W)new MutationObserver(brand).observe(D.body,{childList:true,subtree:true})}catch(e){}}

  var tries=0;
  function boot(){
    var ok=false;try{ok=q1Ready()&&typeof W.render==='function'&&typeof W.back==='function'&&typeof W.start==='function'&&typeof W.restart==='function'}catch(e){}
    if(!ok){if(tries++<200)setTimeout(boot,50);else{var it=$('intro');if(it)it.classList.add('nsh-q1-fail')}return}
    install();
    /* first screen, unless a result is already shown (?state= links, own result link). A quiz screen left open by an early
       start() (old ?start=1 links are stripped inline; this is the fallback) is replaced too. */
    try{var r=$('result');if(!r||r.classList.contains('hidden'))first(false)}catch(e){}
    /* late painters: the #intro top line (locale scripts, nsh-quiz-num.js) and the carry notice */
    try{var it=$('intro');if(it&&'MutationObserver' in W)new MutationObserver(function(){
      if(!onFirst())return;moveIn();var ld=$('nshSeqLead');if(ld)topLine(ld)}).observe(it,{childList:true,subtree:true,characterData:true})}catch(e){}
  }
  if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',function(){brandWatch();boot()});else{brandWatch();boot()}
})();